<div class="container-fluid mt-4 mb-5" *ngIf="!isLoading">
    <div class="row m-2">
        <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
    </div>
    <div class="row m-2">
        <ng-container *ngFor="let product of products">
            <div class="col" *ngIf="product.name !== 'Free (Internal)'">
                <mat-card class="mat-elevation-z8 h-100 p-3">
                    <div id="card-header" class="row justify-content-center">
                        <div class="row text-center">
                            <mat-toolbar *ngIf="currentSubscription.productId === product.id"
                                class="current-subscription">
                                <p style="width: 100%;">Current Subscription</p>
                            </mat-toolbar>
                        </div>
                        <div class="row text-center pt-2">
                            <div class="col-12">
                                <h2>{{product?.name}}</h2>
                            </div>
                            <div class="col-12">
                                <h3 class="mat-h3">{{product.metadata['price']}}</h3>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div id="card-body" class="row mb-3">
                        <div class="col">
                            <ul *ngFor="let feature of product?.metadata | keyvalue">
                                <ng-container *ngIf="feature?.key.includes('feature')">
                                    <li>{{ feature?.value }}</li>
                                </ng-container>
                            </ul>
                        </div>
                    </div>
                    <div id="card-actions" class="row">
                        <div class="col text-center">
                            <button mat-raised-button
                                *ngIf="currentSubscription.active && currentSubscription.productId !== product.id"
                                (click)="createSubscription(product)">Select</button>
                        </div>
                    </div>
                </mat-card>
            </div>
        </ng-container>
    </div>
</div>
<ng-container *ngIf="isLoading">
    <my-account-subscriptions-skeleton></my-account-subscriptions-skeleton>
</ng-container>